import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../services/api";
import StandardCakesTable from "./StandardCakesTable";
import StandardCakeFormModal from "./StandardCakeForm/StandardCakeFormModal";

const StandardCakes = () => {
  const [standardCakes, setStandardCakes] = useState([]);
  const [selectedCake, setSelectedCake] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [flavorOptions, setFlavorOptions] = useState([]);
  const [sizeOptions, setSizeOptions] = useState([]);
  const [icingOptions, setIcingOptions] = useState([]);
  const [colorOptions] = useState([
    "white",
    "blue",
    "pink",
    "red",
    "green",
    "yellow",
    "brown",
  ]);

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    try {
      const [cakesRes, flavorsRes, sizesRes, icingRes] = await Promise.all([
        api.get("/standard-cakes"),
        api.get("/flavors"),
        api.get("/sizes"),
        api.get("/icings"),
      ]);
      setStandardCakes(cakesRes.data);
      setFlavorOptions(flavorsRes.data);
      setSizeOptions(sizesRes.data);
      setIcingOptions(icingRes.data);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/standard-cakes/${id}`);
      setStandardCakes((prev) => prev.filter((cake) => cake._id !== id));
    } catch (error) {
      console.error("Error deleting cake:", error);
    }
  };

  const handleEdit = (cake) => {
    setSelectedCake(cake);
    setIsModalOpen(true);
  };

  const handleAdd = () => {
    setSelectedCake(null);
    setIsModalOpen(true);
  };

  return (
    <Box sx={{ padding: "1rem" }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}>
        <Typography variant="h4">Manage Standard Cakes</Typography>
        <Button variant="outlined" startIcon={<AddIcon />} onClick={handleAdd}>
          Add Standard Cake
        </Button>
      </Stack>

      <StandardCakesTable
        standardCakes={standardCakes}
        onDelete={handleDelete}
        onEdit={handleEdit}
      />

      <StandardCakeFormModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={fetchInitialData}
        cakeData={selectedCake}
        flavorOptions={flavorOptions}
        sizeOptions={sizeOptions}
        icingOptions={icingOptions}
        colorOptions={colorOptions}
      />
    </Box>
  );
};

export default StandardCakes;
